/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconVectorTriangleOff = createSolidComponent(
  "vector-triangle-off",
  "IconVectorTriangleOff",
  [
    [
      "path",
      { d: "M10 6v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1" }
    ],
    [
      "path",
      {
        d: "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
      }
    ],
    [
      "path",
      {
        d: "M20.705 20.709a1 1 0 0 1 -.705 .291h-2a1 1 0 0 1 -1 -1v-2c0 -.28 .115 -.532 .3 -.714"
      }
    ],
    ["path", { d: "M6.5 17.1l3.749 -6.823" }],
    ["path", { d: "M13.158 9.197l-.658 -1.197" }],
    ["path", { d: "M7 19h10" }],
    ["path", { d: "M3 3l18 18" }]
  ]
);

export { IconVectorTriangleOff as default };
//# sourceMappingURL=IconVectorTriangleOff.js.map
